// extracted by mini-css-extract-plugin
export var mainContent = "styles-module--mainContent--d606d";